import { Component, ElementRef, EventEmitter, Input, Output, TemplateRef, ViewChild } from "@angular/core";
import { EmailService } from "../../../../../services/emailService";
import { Order } from "../../../../../objects/orders/order";
import { WizardComponent } from "ngx-wizard";
import { GoogleTagService } from "../../../../../services/google-tag.service";
import { PageVisit } from "../../../../../objects/pages/pageVisit";

@Component({
    selector: "ask-question-tab",
    templateUrl: "./ask-question-tab.component.html",
    moduleId: module.id.toString()
})

export class AskQuestionTabComponent {

    @ViewChild("questionText")
    public questionText: ElementRef;
    @Input()
    public order: Order;
    @Input()
    public wizard: WizardComponent;
    @Input()
    public wizardFooterTemplate: TemplateRef<any>;
    @Output()
    public thanksTabShow: EventEmitter<boolean> = new EventEmitter<boolean>();
    @Input()
    public isAskQuestionTabShow: boolean;
    @Input()
    public isQuestionOrCallTabShow: boolean;
    @Output()
    public onTabSelected: EventEmitter<PageVisit> = new EventEmitter<PageVisit>();

    public emailText: string;

    constructor(public emailService: EmailService,
                public googleTagService: GoogleTagService) {
    }

    public backToThanksTab() {
        const isTextEmpty = String.isNullOrEmpty(this.questionText.nativeElement.value);
        if (!isTextEmpty) {
            this.emailText = this.questionText.nativeElement.value;
            this.emailService.sendQuestionEmailToAgent(this.order.Customer.Email, this.emailText);
        }

        this.thanksTabShow.emit(true);
        setTimeout(_ => this.wizard.previousTab(false), 0);
    }

    public backToQuestionOrCallTab(backEvent: any) {
        backEvent.preventDefault();
        this.thanksTabShow.emit(false);
        setTimeout(_ => this.wizard.previousTab(false), 0);
    }

}


// WEBPACK FOOTER //
// ./app/components/calculator/public/mobile/ask-question-tab/ask-question-tab.component.ts